<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm6 md12>
        <v-card color="white">
          <v-card-title primary class="title grey ">
            <span><v-icon large color="white">location_on</v-icon></span>{{privateDataPolicyNavTitle}}
          </v-card-title>
          <!--<v-card-text>
            {{privateDataPolicyText}}
          </v-card-text>-->
          <div v-for="(item, index) in tabelItems" :key="index">
            <v-card-title v-if="item.title.length > 0" primary class="title">{{item.title}}</v-card-title>
            <v-card-text>{{ item.text }}</v-card-text>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import * as dataOfPrivatePolicy from './impressum-private-policy/datenschutzerklarung'
  import { EventBus } from '../events'

  export default {
    data: () => {
      return {
        tabelItems: [],
      }
    },
    computed: {
        ...mapState('ContactModule', ['privateDataPolicyText', 'privateDataPolicyNavTitle']),
        ...mapGetters('ContactModule', {
          languageSelected: 'language',
        }),
    },
    components: {
    },

    mounted(){
      this.updateParagraphs(this.languageSelected)

      EventBus.$on('language', lang => {
        this.updateParagraphs(lang)
      })
    },
    methods: {
      updateParagraphs(val){
        console.log(dataOfPrivatePolicy.data.de.paragraphs)
        console.log(dataOfPrivatePolicy.data.en.paragraphs)
        if(val == 'DE'){
          this.tabelItems = dataOfPrivatePolicy.data.de.paragraphs
        } else {
          this.tabelItems = dataOfPrivatePolicy.data.en.paragraphs
        }
      }
    }
  }
</script>